/**
 * App-wide constants
 */

// Marco Fashion Logo
export const ASHISH_LOGO_URL = "/marco-logo.png";

// Logo for footer/dark backgrounds
export const ASHISH_LOGO_WHITE_URL = "/marco-logo-white.png";

// Company brand colors
export const BRAND_PRIMARY_COLOR = "#1F2937"; // Dark Gray
export const BRAND_SECONDARY_COLOR = "#FFFFFF"; // White

// App name
export const APP_NAME = "Marco Fashion";
export const APP_DOMAIN = "marco-fashion.com";
